import {
  createApi,
  fetchBaseQuery,
  type FetchArgs,
  type BaseQueryFn,
  type FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'
import { API_MENU_SERVICE_ENDPOINT } from '@/utils/config'
import { mutex } from '@/store'

const baseQuery = fetchBaseQuery({
  baseUrl: API_MENU_SERVICE_ENDPOINT,
  credentials: 'include',
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  },
})

const getBaseQueryWithRefresh = (
  baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  return async (args, api, extraOptions) => {
    await mutex.waitForUnlock()
    let result = await baseQuery(args, api, extraOptions)

    if (
      result.error &&
      (result.error.status === 401 || result.error.data === 'Unauthorized')
    ) {
      if (!mutex.isLocked()) {
        const release = await mutex.acquire()
        try {
          const token = localStorage.getItem('accessToken')
          if (!token) {
            window.location.reload()
          }

          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const refresh: any = (
            await baseQuery(
              { url: '/v1/web/auth/refresh', method: 'POST' },
              api,
              extraOptions
            )
          )?.data

          if (refresh?.access_token) {
            localStorage.setItem('accessToken', refresh.access_token)
            result = await baseQuery(args, api, extraOptions)
          } else {
            localStorage.removeItem('accessToken')
            localStorage.removeItem('refreshToken')
            window.location.reload()
          }
        } finally {
          release()
        }
      } else {
        await mutex.waitForUnlock()
        result = await baseQuery(args, api, extraOptions)
      }
    }
    return result
  }
}

export const apiMedService = createApi({
  reducerPath: 'apiMedService',
  keepUnusedDataFor: 60 * 60,
  refetchOnFocus: true,
  baseQuery: getBaseQueryWithRefresh(baseQuery),
  endpoints: () => ({}),
})
